import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';

import { MarketplacePageComponent } from '../../marketplace/marketplace.component';
import { environment } from '../../../../environments/environment';
import { LocalServiceService } from '../../../shareModule/services/local-service.service';
import { AuthServiceService } from '../../../shareModule/services/auth-service.service';
import { MemberNotificationService } from '../../../shareModule/services/member-notification.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { TagSelectorComponent } from '../../community/tag-selector/tag-selector.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, takeUntil } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'common-product-card-view',
  templateUrl: './common-product-card-view.component.html',
  styleUrls: [
    './common-product-card-view.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommonProductCardViewComponent implements OnInit, AfterViewChecked, OnChanges, OnDestroy {
  @Input() isCommunityProduct: boolean = false;
  @Input() isSearch: boolean = false;
  @Input() list: any = {};
  @Input() ads: boolean = false;
  @Input() d: any = {};
  @Input() withHighlight = false;
  @Input() toSinglePage: boolean = false;
  @Input() canBeSelected: boolean = false;
  @Input() isSelected: boolean = false;
  @Input() postalCode: any = {};
  @Input() isUpvote: boolean = false;
  @Input() filterMapsIcon: any = []
  public viewCount = 0

  @Output() view = new EventEmitter<any>();// Event to view product 

  @Output() selected = new EventEmitter<boolean>(); //whether  to thhe productis selected or not

  public selectedChanged() {
    this.selected.emit(this.isSelected);
  }

  public get isBrowser() {
    return this.sharedService.isBrowser();
  }

  public specialTags = new Set(['Preferred', 'Top Seller']);

  public get isThereValidCropInformation(): boolean {

    const cropInfo = this.list?.mainImageCropInformation;
    if (!cropInfo || cropInfo == 'null' || cropInfo == 'undefined') {
      return false;
    }
    try {
      const data = (typeof cropInfo == 'object') ? cropInfo : JSON.parse(cropInfo);
      const { isYAxisTheOneThatIsLocked, offsetRatio, imageAspectRatio } = data;
      const neededData = [isYAxisTheOneThatIsLocked, offsetRatio, imageAspectRatio]
      return !neededData.includes(null) && !neededData.includes(undefined);


    } catch (e) {
      return false;
    }
  }

  public moduloIncreaseDollarSign() {
    this.auth.moduloIncreaseDollarSignRating(this.list?.id)
      .subscribe({
        next: () => {
          this.toastr.success("Increased")

          this.list.dollarSignRating += 1
          this.list.dollarSignRating %= 4

        },
        error: err => {
          console.error(err);
          this.toastr.error("Something went wrong")
        }
      })
  }

  openSuggestionPopup() {
    const ref = this.modalService.open(TagSelectorComponent, {
      size: "sm",
      centered: true
    });
    ref.componentInstance.productId = this.list.id
    return ref
  }

  public imgUrl = environment.ImageUrl;
  public isLogin: any = 0;
  public latLong: any = {};

  constructor(
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private memberNotificationService: MemberNotificationService,
    public roleService: RoleService,
    public commonService: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    @Inject("WINDOW") private window: any,
    private cdr: ChangeDetectorRef
  ) { }
  ngOnChanges(changes: SimpleChanges): void {

    // Check Within Radius
    const postalCode = changes['postalCode']
    if (postalCode?.currentValue?.lat && postalCode?.currentValue?.lng) {
      // this.latLong = postalCode;
      const modifiedList = { ...this.list };
      if (modifiedList?.latLong && modifiedList.latLong != '{}') {
        const latLong = JSON.parse(modifiedList.latLong);
        const isWithinRadius = this.local.isWithinRadius(latLong, postalCode?.currentValue, 5);
        modifiedList.isWithinRadius = isWithinRadius.check;
        modifiedList.distance = isWithinRadius.distance;
        this.list = modifiedList;
      }
    } else {
      this.list.isWithinRadius = false;
      this.list.distance = 0;
    }


    if (changes['list']) {
      this.loadMoreBadges();
    }

  }
  ngAfterViewChecked(): void {
    this.loadMoreBadges();
    this.cdr.detectChanges();
  }

  public categoryImage = '';
  public timeout1: any;

  ngOnInit(): void {
    //this.loadForums()
    this.local.getUserDetailsObserver()
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (user) => {
        if (user?.id) {
          this.isLogin = 1;
          this.latLong = user.latLong;
        } else {
          this.isLogin = 0;
        }


      });


    // Create a shallow copy of the list object to avoid modifying the original input
    const modifiedList = { ...this.list };

    if (!modifiedList.foodImages) {
      modifiedList.foodImages = modifiedList.memberShopProductsImages;
    }

    if (modifiedList.user_detail?.shop_name === 'null') {
      modifiedList.user_detail.shop_name = null;
    }

    if (modifiedList.type == "rental") {
      modifiedList.name += ' - RENTAL'
    }




    this.list = modifiedList; // Update the list reference

    this.viewCount = this.list.viewCount
    this.cdr.detectChanges();


  }


  private destroy$ = new Subject<void>();
  ngOnDestroy(): void {
    if (this.timeout1) {
      clearTimeout(this.timeout1)
    }
    this.destroy$.next()
    this.destroy$.complete();
  }

  public roleSubscription() {
    this.roleService.rolesSubject
      .pipe(takeUntil(this.destroy$))
      .subscribe(roles => {
        console.log('roles', roles)
        // this.cdr.detectChanges();
      })
  }

  public otherRatingBadges = [];
  public otherRatingBadgesConfig = {
    slidesPerView: 1,
    autoPlay: true,
    navigation: false
  }
  private loadMoreBadges() {
    this.cdr.detectChanges();
    if (this.otherRatingBadges?.length) {
      return;
    }
    this.otherRatingBadges = [];
    if (this.list && 'seller_info' in this.list) {
      try {
        let sellerInfo = this.list['seller_info'];
        if (typeof sellerInfo == 'string') {
          sellerInfo = JSON.parse(this.list['seller_info']);
        }

        if (sellerInfo) {
          if ('superDealRating' in sellerInfo && (sellerInfo.superDealRating || sellerInfo.superDealText)) {
            this.otherRatingBadges.push({
              icon: 'super_deal_1.png',
              name: 'Super Deal',
              rating: sellerInfo.superDealRating,
              text: sellerInfo.superDealText,
            })
          }

          if ('bestPriceRating' in sellerInfo && (sellerInfo.bestPriceRating || sellerInfo.bestPriceText)) {
            this.otherRatingBadges.push({
              icon: 'best_price_1.png',
              name: 'Best Price',
              rating: sellerInfo.bestPriceRating,
              text: sellerInfo.bestPriceText
            })
          }

          if ('highQualityRating' in sellerInfo && (sellerInfo.highQualityRating || sellerInfo.highQualityText)) {
            this.otherRatingBadges.push({
              icon: 'high_quality_1.png',
              name: 'Hight Quality',
              rating: sellerInfo.highQualityRating,
              text: sellerInfo.highQualityText
            })
          }
        }
      } catch (e) {
        console.warn(e)
      }
    }
    this.cdr.detectChanges();
  }

  public regionSplit(name: string): string {
    if (name && name.includes(',')) {
      let data = name.split(',');
      return `${data[0]}, ${data[1].trim().charAt(0)}`
    } else {
      return name;
    }
  }

  public goToBiz(list: any) {
    this.router.navigate(['/biz/shop', list?.adminId], {
      state: {
        scrollPosition: [this.window.scrollX, this.window.scrollY]
      }
    })
  }

  handleInfoAP() {
    this.local.alertInfo({
      title: `<p style="color: var(--primary)">AP (Ambassador Program)</p>`,
      message: `
      <p style="color: var(--primary)">Business is running a loyalty program to reward referrals and believers in their product & services. This payment is only redeemable via PAYNOW. Please contact support if you have any questions. Participation is not mandatory. T&C applies.</p>
    `,
    });
  }

  public get isVerified(): boolean {
    return this.list.productVerficationsList && this.list.productVerficationsList.length > 0
  }
  @ViewChild('discussDialog')
  public discussDialog: TemplateRef<any>
  public openDiscuss(productData) {
    this.loadForums();
    this.modalService.open(this.discussDialog, { size: 'sm' })
  }

  public productForum = null
  public repliesHolders = []



  private _fetchForumReplies(forum) {
    //console.log({ forum })
    this.auth.marketplace_forum_shop_fetch_reply(forum?.id, 1, true, false, 3)
      // .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          console.log({ data })
          forum.replies = data.body
        }
      })
  }

  @ViewChild('addComment')
  public addCommentModal;
  public openAddCommentModal(forum) {
    ;
    this.modalService.open(this.addCommentModal, { size: 'md', centered: true })
  }
  public repliesHolder = '';
  public addPostToForum() {
    if (!this.repliesHolder) {
      return;
    }
    const form = {
      forumId: this.productForum?.id,
      message: this.repliesHolder,
      createdBy: this.local.getUser()?.id,
      // id: id,
      // isChild: isChild,
      // parentChild: parentChild,
    };

    // console.log({ form }, this.repliesHolder)
    try {
      this.auth.marketplace_forum_shop_store_reply(form).
        subscribe({
          next: () => {
            this.loadForums();
            this.toastr.success("Posted");
            this.modalService.dismissAll();
          },
          error: err => {
            console.error(err);
            this.toastr.error("Something went wrong while posting response")
          }
        });
    } catch (e) {
      console.error(e)
    }
  }
  public loadForums() {
    //this.auth.getPagesLinkToForums('product', this.list?.id)

    this.auth.marketplace_forum_shop_fetch_by_shopId(this.list?.id)
      //.pipe(takeUntil(this.destroy$))
      .subscribe(
        {
          next: (data: any) => {
            // for(const selected of data.body){
            //   this.linkedForum.add(selected.forumId)
            // }
            //console.log(data.body)

            this.productForum = structuredClone(data.body.data[0]);
            console.log({ data })
            this._fetchForumReplies(this.productForum)





          },
          error: console.error
        }
      )

  }
  private favProduct(item) {
    const param = !this.window.location.href.includes('/biz') && !item?.user_detail ? 'member_product_id' : 'foodId';
    this.auth
      .marketplace_favorite_product({
        [param]: item.id,
        isAdmin: false,

      })
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        this.list.foodFavoritesCount = response.body?.length || 0;
        this.list.isFavorite = !this.list.isFavorite
        if (this.list.isProfile) {
          this.sharedService.triggerProfileService({});
        }
        this.memberNotificationService.getNotification();
      });
  }


  public favoriteProduct(item: any) {
    if (this.isLogin) {
      if (!item.isFavorite) {
        const title = this.isUpvote ? 'Upvote' : 'Favourites';
        const text = this.isUpvote ? 'Add to Upvote ' : 'Add to Favourites ';
        this.local.confirmYesNo({ title, text, icon: 'question' })
          .then(
            c => {
              if (c.isConfirmed) {
                this.favProduct(item)
              }
            }
          )

      }
      else {
        this.favProduct(item)
      }
    } else {
      document.getElementById('loginBtn').click();
    }

  }
  public get isMemberProduct() { return 'appUser' in this.list; }
  isAdmin = () => this.roleService?.roles?.userType.includes('ADMIN')


  public setVerifiedTag(event) {
    const value = event.target.value
    this.auth.editShopProduct({ verifiedTag: value, productId: this.list?.id }).subscribe({
      next: () => {
        this.toastr.success("Changed");
      },
      error: err => {
        console.error(err);
        this.toastr.error("Error something went wrong while changing")
      }

    });

  }



  @ViewChild('changeTag') changeTag: TemplateRef<any>

  public openEditVerifiedTag() {
    if (!this.isAdmin()) {
      return;
    }
    this.modalService.open(this.changeTag, { size: 'sm' }).closed.subscribe(() => {
      this.modalService.dismissAll();
    })
  }

  public viewProductDetails(product): void {
    if (this.toSinglePage) {
      const slug = product.slug
      this.router.navigate(['/product', slug])
    } else {
      try {

        if (product.seller_info) {
          product.seller_info = JSON.parse(product.seller_info);
        }

      } catch (e) {
      }
      this.view.next(product);
      //this.viewCount += 1
      if (this.isMemberProduct) {
        this.auth.increaseViewCountOfProduct(product.id)
          .pipe(takeUntil(this.destroy$))
          .subscribe({ error: console.error })
      }
    }
  }
}
